import React from "react";
import {autobind} from "core-decorators";
import {Button, Tooltip} from "antd";
import {FaEdit} from "react-icons/fa";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";

import {PiecesQuery} from "@/graphql/types";
import EditPieceModal from "./EditPieceModal";
import Store from "@/stores";

export interface IEditPieceActionProps {
  piece: PiecesQuery["pieces"][0];
  pieces: PiecesQuery["pieces"];
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class EditPieceAction extends React.Component<IEditPieceActionProps> {
  @observable modalOpen: boolean = false;

  closeModal() {
    this.setModalOpen(false);
  }

  openModal() {
    this.setModalOpen(true);
  }

  @action
  setModalOpen(open: boolean) {
    this.modalOpen = open;
  }

  public render() {
    const {piece, pieces} = this.props;
    return (
      <>
        <EditPieceModal piece={piece} pieces={pieces} open={this.modalOpen} close={this.closeModal} />
        <Tooltip title="Edit" placement="topLeft" arrowPointAtCenter>
          <Button type="link" shape="circle" size="small" onClick={this.openModal}>
            <FaEdit />
          </Button>
        </Tooltip>
      </>
    );
  }
}
